/**
 *
 * @module component/extender
 * @author Greg Babula [greg.babula@mlb.com]
 * @see ./example/simple/component/extender
 *
 */

/**
 *
 * @function extender
 * @param {Object} data
 * @param {Object} opts shared options
 * @desc component data extender
 * @returns {Object} extended data
 *
 */
function extender(data={}, opts={}) {
    return data;
}

export default extender;
